'use strict';
'use es6';

/**
 * PubNubMessage Status Types
 *
 * SCHEDULED:
 *
 * The message will be publish if the visitor responds to it.  It will be rendered as if it has been published.
 *
 * SIMULATED:
 *
 * The message is presentational and will not be published. It will be rendered as if it has been published.
 *
 * UNPUBLISHED:
 *
 * The message has not yet been published.
 *
 * PUBLISHED:
 *
 * The message has been published.
 *
 * PUBLISH_FAILED:
 *
 * The message has failed to publish.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCHEDULED = exports.SCHEDULED = 'SCHEDULED';
var SIMULATED = exports.SIMULATED = 'SIMULATED';
var UNPUBLISHED = exports.UNPUBLISHED = 'UNPUBLISHED';
var PUBLISHED = exports.PUBLISHED = 'PUBLISHED';
var PUBLISH_FAILED = exports.PUBLISH_FAILED = 'PUBLISH_FAILED';